import { useReState } from '@raulpesilva/re-state';
import { type SetReStateAction } from '@raulpesilva/re-state/types/core/types';
import { type DispatchReState } from '@raulpesilva/re-state/types/react/types';

export default function useGlobalStorage<T = undefined>(key: string, initialValue: T extends undefined ? any : T) {
    const [value, setValue] = useReState(key, initialValue);
    return [value, setValue] as [T, DispatchReState<SetReStateAction<T extends undefined ? any : T>>];
}
